import React, { useEffect, useState } from "react";
import DeleteExpense from "../../../Controllers/Admin/Expense/DeleteExpense";
import GetAllExpenses from "../../../Controllers/Admin/Expense/GetAllExpenses";

const ExpensesViewModal = () => {
  const [AllExpenses, setAllExpenses] = useState();
  const [Refresh, setRefresh] = useState(false);
  const [ExpenseId, setExpenseId] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      let resp = await GetAllExpenses();
      if (resp) {
        setAllExpenses([...resp]);
      }
    };
    fetchData();
    setIsLoading(false);
  }, [Refresh]);

  // Action Confirmation Start
  const [DeleteDialog, setDeleteDialog] = useState(false);

  const handleOpenDeleteDialog = (id) => {
    setExpenseId(id);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await DeleteExpense(ExpenseId);
      setDeleteDialog(false);
      setRefresh(!Refresh);
    }
  };
  // Action Confirmation End
  return {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    AllExpenses,
    isLoading,
  };
};

export default ExpensesViewModal;
